const root = {
  backgroundColor: 'white',
  borderRadius: '0px',
};

const getStyles = (theme) => ({
  title: {
    userSelect: 'none',
    fontWeight: 700,
    fontFamily: 'Source Sans Pro',
    fontSize: 12,
    [theme.breakpoints.up('xs')]: {
      fontSize: 16,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 20,
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: 20,
    },
  },
  titleColor: {
    color: theme.palette.text.main,
    fontWeight: 100,
  },
  titleMargin: {
    marginLeft: '5px',
  },
  notchedOutline: {
    border: '1px solid rgba(204, 204, 204, 1)',
  },
  inputLightRoot: {
    ...root,
    border: '1px solid rgba(204, 204, 204, 1)',
  },
  inputDarkRoot: {
    ...root,
    border: '1px solid rgba(204, 204, 204, 1)',
  },
  inputOutlined: {
    padding: '13px 14px',
    fontFamily: 'Source Sans Pro',
  },
});

export default getStyles;
